import React, { useContext } from 'react';
import { useStaticQuery, Link, graphql } from 'gatsby';
import {
  NavWrapper,
  InnerNavWrapper,
  SideBarWrapper,
  Toggle,
  Notch,
  OuterNavWrapper,
} from '../elements';
import AppContext from '../context/index';
import { BsSun, BsMoon } from 'react-icons/bs';

export const Nav = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "ak-white.png" }) {
        publicURL
      }
    }
  `);

  const { dark, setTheme } = useContext(AppContext);

  return (
    <OuterNavWrapper dark={dark}>
      <NavWrapper>
        <SideBarWrapper />
        <InnerNavWrapper>
          <ul>
            <li style={{ marginLeft: 0 }}>
              <Link to='/' style={{ display: 'flex', alignItems: 'center' }}>
                <img src={data.logo.publicURL} alt='AK' />
              </Link>
            </li>
            <li
              style={{
                marginLeft: 'auto',
              }}
            >
              <Link
                to='/'
                style={{ color: 'white', textDecoration: 'none' }}
                className='text-link'
              >
                Home
              </Link>
            </li>
            <li>
              <a
                href='https://github.com/anishkoulgi'
                style={{ color: 'white', textDecoration: 'none' }}
                className='text-link'
              >
                GitHub
              </a>
            </li>
            <li style={{ marginRight: 0 }}>
              <BsSun
                style={{
                  marginRight: '0.5rem',
                  color: dark ? '#445868' : '#ffee00',
                }}
              />
              <Toggle dark={dark} onClick={setTheme}>
                <Notch dark={dark}></Notch>
              </Toggle>
              <BsMoon
                style={{
                  marginLeft: '0.5rem',
                  color: dark ? 'white' : '#c3e4f7',
                }}
              />
            </li>
          </ul>
        </InnerNavWrapper>
        <SideBarWrapper />
      </NavWrapper>
    </OuterNavWrapper>
  );
};
